import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TaskNavigationService {
  private _taskId: string | null = null;

  setTaskId(id: string) {
    this._taskId = id;
  }

  getTaskId(): string | null {
    return this._taskId;
  }

  clearTaskId() {
    this._taskId = null;
  }
}
